import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const BlogListingWithFilter = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const featureData = module.selectFeatureBlog
  const data = useStaticQuery(graphql/* GraphQL */ `
    query AllPostQuery {
      allWpCategory(
        filter: { slug: { ne: "feature-post" } }
        sort: { slug: DESC }
      ) {
        nodes {
          id
          link
          name
          slug
        }
      }
      allWpPost(
        sort: { date: DESC }
        filter: {
          categories: { nodes: { elemMatch: { slug: { ne: "feature-post" } } } }
        }
      ) {
        nodes {
          excerpt
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          blogContent {
            bannerImage {
              mediaItemUrl
            }
          }
          id
          title
          uri
          date(formatString: "D MMMM yyyy")
          categories {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  `)

  const categories = data.allWpCategory.nodes
  const allBarData = data.allWpPost.nodes

  const exFixLimit = 100
  const [experinceLimit, setExLimit] = useState(exFixLimit)
  const [cExLimit, setCexLimit] = useState(exFixLimit)

  const [tabDetails, setTabDetails] = useState(allBarData.slice(0, exFixLimit))
  const [tabOption, setTabOption] = useState("all")

  useEffect(() => {
    if (tabOption !== "all") {
      const arrayData = []
      for (var i = 0; i < allBarData.length; i++) {
        for (var j = 0; j < allBarData[i].categories.nodes.length; j++) {
          if (allBarData[i].categories.nodes[j].name === tabOption) {
            arrayData.push(allBarData[i])
          }
        }
      }
      setCexLimit(arrayData.length)
      setTabDetails(arrayData.slice(0, experinceLimit))
    } else {
      setCexLimit(allBarData.length)
      setTabDetails(allBarData.slice(0, experinceLimit))
    }
  }, [tabOption, allBarData, experinceLimit])

  const handleSelectChange = event => {
    setExLimit(exFixLimit)
    setTabOption(event.target.value)
  }

  if (module.hideSection === "no") {
    return (
      <>
        {module?.selectFeatureBlog && (
          <motion.section
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="img-with-content pb-50"
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="container-fluid"
            >
              <div className="border-1 border-charcoal rounded-2 py-50 px-80 xlscreen:px-40 lgscreen:px-20 lgscreen:py-20">
                <div className="flex flex-wrap items-center">
                  <div className="lg:w-6/12 w-full">
                    {featureData?.featuredImage && (
                      <motion.div variants={animFade} className="img relative">
                        <ImageOpt
                          imgData={featureData.featuredImage.node.mediaItemUrl}
                          width={900}
                          height={500}
                          imgAlt={featureData.featuredImage.node.altText}
                          imgLoad="lazy"
                        />
                      </motion.div>
                    )}
                  </div>
                  <div className="lg:w-6/12 w-full">
                    <div className="img-with-content-inner pl-80 xlscreen:pl-40 lgscreen:pl-0 lgscreen:pt-30">
                      <motion.h3
                        variants={animFade}
                        className="font-ositalic normal-case tracking-[0px]"
                      >
                        {featureData.title}
                      </motion.h3>
                      {featureData?.excerpt && (
                        <motion.div
                          variants={animFade}
                          className="content pt-15"
                        >
                          {parse(featureData.excerpt)}
                        </motion.div>
                      )}
                      {featureData?.date && (
                        <motion.div
                          variants={animFade}
                          className="flex flex-wrap items-center gap-x-[5px] mt-20"
                        >
                          <img
                            src="../images/edit_calendar.svg"
                            className="relative -top-2"
                            width={12}
                            height={12}
                            loading="lazy"
                            alt="Event"
                          />
                          <span className="font-ositalic text-13">
                            {featureData.date}
                          </span>
                        </motion.div>
                      )}

                      <motion.div
                        variants={animFade}
                        className="flex flex-wrap gap-x-2 mt-30 gap-y-2 smscreen:w-full"
                      >
                        <Link to={featureData.uri} className="btn btn-border">
                          read more
                        </Link>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.section>
        )}

        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`bg-white-100 ${
            module.extraClass ? `${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className={`category-listing pt-70 pb-65 lgscreen:pt-35 lgscreen:pb-60${
              module.extraClass ? ` ${module.extraClass}` : ""
            }`}
            id={module.extraId}
          >
            <motion.div variants={animFade}>
              <ul className="tabs w-full flex flex-wrap justify-center gap-x-8 gap-y-5 smscreen2:hidden">
                <li
                  onClick={() => {
                    setExLimit(exFixLimit)
                    setTabOption("all")
                  }}
                  className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50 test  ${
                    tabOption === "all" ? "tab-current" : ""
                  }`}
                  onKeyDown={() => {
                    setExLimit(exFixLimit)
                    setTabOption("all")
                  }}
                  aria-hidden="true"
                >
                  All
                </li>

                {categories.map((item, i) => {
                  return (
                    <li
                      key={i}
                      onClick={() => {
                        setExLimit(exFixLimit)
                        setTabOption(item.name)
                      }}
                      className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                        tabOption === item.name ? "tab-current" : ""
                      }`}
                      onKeyDown={() => {
                        setExLimit(exFixLimit)
                        setTabOption(item.name)
                      }}
                      aria-hidden="true"
                    >
                      {item.name}
                    </li>
                  )
                })}
              </ul>
              <div className="mobileDropdown hidden smscreen2:block w-[310px] mx-auto relative">
                <img
                  className="absolute right-0 top-[10px]"
                  src="https://kove.fluxfullcircle.com/app/uploads/2023/09/Vector-34.svg"
                  alt=""
                />
                <select
                  className="border-b-1 border-charcoal w-full pb-5 !outline-none !bg-none !appearance-none"
                  onChange={handleSelectChange}
                  value={tabOption}
                >
                  <option value="all">All Restaurants & Bars...</option>
                  {categories.map((item, i) => (
                    <option key={i} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </motion.div>
            <div className="container-fluid">
              <div className="accordian-container">
                <div className="tab-content">
                  <div className="flex flex-wrap mt-50 lgscreen:mt-30 -mx-20 lgscreen:mx-0 gap-y-[120px] lgscreen:gap-y-[50px] mdscreen:gap-y-[25px]">
                    {tabDetails.length > 0 &&
                      tabDetails.map((item, i) => {
                        return (
                          <div
                            className="lg:w-4/12 w-full px-20 lgscreen:px-0"
                            key={i}
                          >
                            <motion.div
                              variants={animFade}
                              className="category-bx"
                            >
                              {item?.featuredImage ? (
                                <Link to={item.uri}>
                                  <div className="img relative">
                                    <ImageOpt
                                      imgData={
                                        item.featuredImage.node.mediaItemUrl
                                      }
                                      width={534}
                                      height={435}
                                      imgAlt={item.featuredImage.node.altText}
                                      imgLoad="lazy"
                                    />
                                  </div>
                                </Link>
                              ) : (
                                <Link to={item.uri}>
                                  <div className="img relative">
                                    <ImageOpt
                                      imgData={
                                        item.blogContent.bannerImage
                                          .mediaItemUrl
                                      }
                                      width={700}
                                      height={400}
                                      imgAlt={
                                        item.blogContent.bannerImage.altText
                                      }
                                      imgLoad="lazy"
                                      imgClass="w-full h-full object-cover"
                                    />
                                  </div>
                                </Link>
                              )}
                              <div className="category-content pt-25">
                                {item?.title && (
                                  <h4 className="font-ositalic normal-case tracking-[0px]">
                                    {item.title}
                                  </h4>
                                )}
                                {item?.excerpt && (
                                  <div className="content w-full pr-30 pt-15">
                                    {parse(item.excerpt)}
                                  </div>
                                )}
                                {item?.date && (
                                  <div className="flex flex-wrap items-center gap-x-[5px] mt-10">
                                    <img
                                      src="../images/edit_calendar.svg"
                                      className="relative -top-2"
                                      width={12}
                                      height={12}
                                      loading="lazy"
                                      alt="Event"
                                    />
                                    <span className="font-ositalic text-13">
                                      {item.date}
                                    </span>
                                  </div>
                                )}

                                <div className="flex flex-wrap gap-x-2 gap-y-2 mt-25">
                                  <Link
                                    to={item.uri}
                                    className="btn btn-border"
                                  >
                                    Read more
                                  </Link>
                                </div>
                              </div>
                            </motion.div>
                          </div>
                        )
                      })}
                  </div>

                  <motion.div
                    variants={animFade}
                    className="flex flex-wrap justify-center mt-65 lgscreen:mt-35"
                  >
                    {experinceLimit < allBarData.length &&
                      cExLimit !== tabDetails.length &&
                      tabDetails.length > 0 && (
                        <button
                          className="btn btn-border opacity-50"
                          onClick={() => {
                            setExLimit(
                              experinceLimit => experinceLimit + exFixLimit
                            )
                          }}
                        >
                          load more
                        </button>
                      )}
                  </motion.div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.section>
      </>
    )
  }
  return null
}

export default BlogListingWithFilter
export const PageBlogListingWithFilterFragment = graphql`
  fragment PageBlogListingWithFilterFragment on WpPage_Pagecontent_PageContent_BlogListingWithFilter {
    extraId
    extraClass
    hideSection
    selectFeatureBlog {
      ... on WpPost {
        id
        title
        uri
        slug
        featuredImage {
          node {
            altText
            mediaItemUrl
          }
        }
        excerpt
        date(formatString: "d MMMM yyyy")
      }
    }
  }
`
